import Table from "components/Table";
import { Fragment } from "react";

export default function TablesSection({ tables, mainHeading }) {
   return (
      <>
         { tables && !!tables.length &&
            tables.map(( table, i ) => {

               if ( !table.columns ) return null;

               const showHeading = tables.length > 1;

               return (
                  <Fragment key={ i }>
                     <Table {...table } heading={ showHeading ? table.heading : undefined }/>

                     <div className="divider"/>
                  </Fragment>
               )
            })
         }
      </>
   )
}